import { JSX, useState } from "react";

import Grid from "@mui/material/Grid";

import { Event } from "utils/history/Event";

import {
	Report,
	Role
} from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { Field } from "core/field/FieldService";

import RoleTable from "core/trajectory/access/RoleTable";
import RolesHeader from "core/trajectory/access/RolesHeader";

export interface RolesOverviewProps {
	roles: Role[];
	information: Field[];
	reports: Report[];

	editable: boolean;

	onChange: (event: Event) => void;
	onDelete: (index: number) => void;
}

export enum Tabs {
	INFORMATION,
	EVALUATION,
	REPORTS,
	ADMIN
}

function RolesOverview(props: RolesOverviewProps): JSX.Element {
	const [selected, setSelected] = useState(Tabs.INFORMATION);

	return (
		<Grid container direction="column">
			<Grid item>
				<RolesHeader selected={selected} onSelect={setSelected} />
			</Grid>
			<Grid item>
				<RoleTable
					selected={selected}
					roles={props.roles}
					information={props.information}
					reports={props.reports}
					editable={props.editable}
					onChange={props.onChange}
					onDelete={props.onDelete}
				/>
			</Grid>
		</Grid>
	);
}

export default RolesOverview;
